import type { IconNode } from '../types';

/**
 * @name shirt-folded-buttons
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkgMjFINWEyIDIgMCAwIDEtMi0yVjRjMC0uNi40LTEgMS0xaDEyYy42IDAgMSAuNCAxIDF2MTVhMiAyIDAgMSAwIDQgMFY3YzAtLjYtLjQtMS0xLTFoLTMiIC8+CiAgPHBhdGggZD0iTTcgM3YxYTMgMyAwIDEgMCA2IDBWMyIgLz4KICA8cGF0aCBkPSJNMTAgMTFoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMCAxNWguMDEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/shirt-folded-buttons
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const shirtFoldedButtons: IconNode = [
  [
    'path',
    {
      d: 'M19 21H5a2 2 0 0 1-2-2V4c0-.6.4-1 1-1h12c.6 0 1 .4 1 1v15a2 2 0 1 0 4 0V7c0-.6-.4-1-1-1h-3',
      key: '1kyhei',
    },
  ],
  ['path', { d: 'M7 3v1a3 3 0 1 0 6 0V3', key: 'v0j97r' }],
  ['path', { d: 'M10 11h.01', key: 'd2at3l' }],
  ['path', { d: 'M10 15h.01', key: '44in9x' }],
];

export default shirtFoldedButtons;
